import { Component, OnInit } from '@angular/core';
import { Claims } from '../../classes/claims';
import { IClaims } from '../../interfaces/claims';
import { SearchInformation } from '../../classes/search-information';
import { NamePipe } from '../../pipes/name.pipe';
import { NgFor } from '@angular/common';
import { ClaimService } from '../../services/claim.service';

@Component({
  selector: 'app-claims-table',
  standalone: true,
  imports: [NgFor],
  templateUrl: './claims-table.component.html',
  styleUrl: './claims-table.component.css'
})
export class ClaimsTableComponent implements OnInit{

  constructor (private claims: Claims, private searchInfo:SearchInformation, private claimsService: ClaimService) {}

  claimsArray: IClaims[] = [];
  iClaimsInterface: IClaims;
  ngOnInit(): void {
    const claimsResponses = this.claims.getClaims();
    const info = this.searchInfo.getPolicy();
    for (let claim of claimsResponses){
      this.iClaimsInterface = {
        claim: claim,
        dol: info.dol,
        firstName: info.firstName,
        lastName: info.lastName,
      }
    this.claimsArray.push(this.iClaimsInterface);
    }
  }

  searchClaim(claimNumber, dol, firstName, lastName){
    this.claimsService.buildRequest(claimNumber, dol, firstName, lastName)
  }

}
